/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Origin_Pattern_DetectionInputs */



/**
* | output |
* | --- |
* | "Pattern Detection" |
*
* @param {Audit_Origin_Pattern_DetectionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_origin_pattern_detection = /** @type {((inputs?: Audit_Origin_Pattern_DetectionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Origin_Pattern_DetectionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mustererkennung")
	return /** @type {LocalizedString} */ ("Pattern Detection")
});